import React from 'react';

const SvgSuccessPreviewAndCustomize = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  viewBox: "0 0 300 300"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "tourlane-EnquiryExperience-SuccessPreviewAndCustomize__linearGradient-5",
  x1: "59.109%",
  x2: "52.737%",
  y1: "54.216%",
  y2: "61.656%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#59DD7D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#50C871"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "tourlane-EnquiryExperience-SuccessPreviewAndCustomize__linearGradient-6",
  x1: "52.22%",
  x2: "50%",
  y1: "63.654%",
  y2: "54.722%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#59DD7D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#59DD7D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#50C871"
})), /*#__PURE__*/React.createElement("path", {
  id: "tourlane-EnquiryExperience-SuccessPreviewAndCustomize__path-1",
  d: "M5.501 0h163.987a5 5 0 015 5v226H.501V5a5 5 0 015-5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "tourlane-EnquiryExperience-SuccessPreviewAndCustomize__path-3",
  d: "M44.532 7.734l8.043 22.028-1.988 16.3-7.678 9.978 4.833 10.743 5.47.47A28 28 0 0174.3 79.896l1.292 1.988 1.645 124.931H17.204c11.268-10.98 15.522-23.474 12.762-37.484-4.14-21.015-6.877-24.945-13.811-31.87C12.138 133.45 1.418 110.499.34 104.13A25.616 25.616 0 019.57 79.869l12.073-9.68V55.375L6.674 26.004C14.465 12.56 18.585 5.836 19.03 5.836c.445 0 4.514-1.946 12.209-5.836l13.292 7.734z"
})), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(14 57)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(83.967)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "tourlane-EnquiryExperience-SuccessPreviewAndCustomize__mask-2",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#tourlane-EnquiryExperience-SuccessPreviewAndCustomize__path-1"
})), /*#__PURE__*/React.createElement("use", {
  fill: "#F7F7F7",
  xlinkHref: "#tourlane-EnquiryExperience-SuccessPreviewAndCustomize__path-1"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#EDEFF0",
  fillRule: "nonzero",
  d: "M184.312 35.16v1.5H-3.364v-1.5z",
  mask: "url(#tourlane-EnquiryExperience-SuccessPreviewAndCustomize__mask-2)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(9.174 23.205)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "tourlane-EnquiryExperience-SuccessPreviewAndCustomize__mask-4",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#tourlane-EnquiryExperience-SuccessPreviewAndCustomize__path-3"
})), /*#__PURE__*/React.createElement("use", {
  fill: "#EDEFF0",
  xlinkHref: "#tourlane-EnquiryExperience-SuccessPreviewAndCustomize__path-3"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#59DD7D",
  d: "M46.8 64.387c4.38 9.731 3.99 15.542-1.17 17.432-7.742 2.834-19.786 2.408-24.498-12.934-.021-.07-12.018-.564-21.132 12.368-3.157 4.48-6.643 15.262-10.458 32.348l18.314 26.821 13.93 42.569c27.37 12.455 47.056 12.455 59.06 0 12.003-12.456 11.563-50.267-1.32-113.433l-8.667-7.568-24.058 2.397z",
  mask: "url(#tourlane-EnquiryExperience-SuccessPreviewAndCustomize__mask-4)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#3F4144",
  d: "M24.082 191.119c25.86 9.782 44.8 12.43 56.818 7.943 18.027-6.73 1.793 17.569 0 17.569s-65.258 1.682-66.245 1.682c-.987 0-9.308-23.513-8.238-23.513.713 0 6.602-1.227 17.665-3.681z",
  mask: "url(#tourlane-EnquiryExperience-SuccessPreviewAndCustomize__mask-4)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#tourlane-EnquiryExperience-SuccessPreviewAndCustomize__linearGradient-5)",
  d: "M34.124 121.176l-6.871-11.624 29.486 31.255-7.83 6.132z",
  mask: "url(#tourlane-EnquiryExperience-SuccessPreviewAndCustomize__mask-4)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#tourlane-EnquiryExperience-SuccessPreviewAndCustomize__linearGradient-6)",
  d: "M22.792 132.317l-4.789 24.424 7.991 13.845 9.428 8.968a11.37 11.37 0 007.835 3.132c2.992 0 5.946-.663 8.65-1.941L91.772 161.9l-13.31-20.686-32.022 20.5c-2.518-4.051-4.873-7.418-7.066-10.098-2.192-2.68-7.72-9.114-16.582-19.3z",
  mask: "url(#tourlane-EnquiryExperience-SuccessPreviewAndCustomize__mask-4)",
  transform: "rotate(-4 54.888 157.501)"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#3F4144",
  d: "M43.36 13.98c13.168 3.183 15.769 21 15.769 21.608 0 .607 18.956 10.948 18.956 14.504 0 .936-1.147 4.382-3.67 8.61-3.018-2.08-5.033-3.751-6.046-5.016-1.592-1.987.208 3.495 4.695 7.144a47.357 47.357 0 01-3.726 4.846c-1.92-1.427-3.265-2.62-4.033-3.578-1.316-1.643-.314 1.818 2.607 5.129l.049-.05c-2.626 2.736-7.919 6.758-15.877 12.068L50.492 76.9c4.93-5.301 7.69-10.74 8.281-16.319.591-5.577-1.417-14.905-6.024-27.982-4.703 3.11-10.404 5.888-17.102 8.332-3.746 1.367-6.857 2.85-9.336 4.448-.9-1.804-1.468-3.24-1.707-4.308-.448-2.009-1.06 1.36.013 5.494-1.185.903-2.18 1.84-2.987 2.812 1.334 7.476 3.137 12.778 5.407 15.904 2.27 3.126 6.55 6.852 12.839 11.176-4.33 2.689-8.405 4.79-12.227 6.303-2.108-2.216-3.498-3.963-4.168-5.241-1.023-1.951-.625 2.082 1.908 6.077-4.651 1.599-8.906 2.277-12.763 2.037-11.337-.706-8.5-13.564-8.5-21.312 0-7.749-8.42-25.496 2.206-38.672C16.957 12.47 30.192 10.795 43.36 13.979z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#EDEFF0",
  d: "M43.006 143.826l-18.294 16.112 10.642 12.08 11.596 11.048a13.965 13.965 0 009.633 3.854c3.587 0 7.038-1.377 9.638-3.848L84.13 166.06l18.363-17.446 11.687-9.67a23.857 23.857 0 005.002-5.703l1.266-2.019a2.235 2.235 0 00-.044-2.443 1.511 1.511 0 00-2.055-.43l-11.827 7.436a94 94 0 01-5.4 3.15l-2.417 1.304c1.715-3.274 3.438-5.651 5.17-7.132 1.762-1.508 1.26-5.203-.92-4.06-2.178 1.144-5.984 4.347-8.768 8.403-1.856 2.703-3.76 5.838-5.713 9.403L59.684 166.06c-3.096-4.99-5.992-9.137-8.688-12.438-2.696-3.302-5.36-6.567-7.99-9.796z"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(22.53 60.308)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 56.209,
  height: 56.119,
  x: 84.461,
  y: 6.891,
  fill: "#FFF",
  stroke: "#EDEFF0",
  strokeWidth: 1.3,
  rx: 2
}), /*#__PURE__*/React.createElement("path", {
  fill: "#3F4144",
  d: "M114.45 28.614l7.216 11.788a2 2 0 01-1.706 3.044h-14.43a2 2 0 01-1.706-3.044l7.215-11.788a2 2 0 013.412 0z"
}), /*#__PURE__*/React.createElement("rect", {
  width: 56.209,
  height: 56.119,
  x: 157.01,
  y: 6.891,
  fill: "#FFF",
  stroke: "#53DD7D",
  strokeWidth: 1.3,
  rx: 2
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 2.941,
  cy: 3.315,
  fill: "#59DD7D",
  rx: 2.941,
  ry: 2.936
}), /*#__PURE__*/React.createElement("path", {
  fill: "#3F4144",
  d: "M186.38 26.223l7.337 7.325a2 2 0 010 2.83l-7.337 7.326a2 2 0 01-2.826 0l-7.337-7.325a2 2 0 010-2.831l7.337-7.325a2 2 0 012.826 0z"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(106.843 153.622)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#C8CCCF",
  d: "M1.856 4.463h127.05v1.305H1.856z"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 3.268,
  cy: 4.881,
  fill: "#C8CCCF",
  stroke: "#F7F7F7",
  strokeWidth: 3,
  rx: 3.268,
  ry: 3.263
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 44.614,
  cy: 4.737,
  fill: "#59DD7D",
  stroke: "#F7F7F7",
  strokeWidth: 4,
  rx: 4.745,
  ry: 4.737
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 86.275,
  cy: 4.881,
  fill: "#C8CCCF",
  stroke: "#F7F7F7",
  strokeWidth: 3,
  rx: 3.268,
  ry: 3.263
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 125.49,
  cy: 4.881,
  fill: "#C8CCCF",
  stroke: "#F7F7F7",
  strokeWidth: 3,
  rx: 3.268,
  ry: 3.263
})), /*#__PURE__*/React.createElement("rect", {
  width: 129.412,
  height: 20.529,
  x: 106.843,
  y: 177.113,
  fill: "#59DD7D",
  rx: 3
}), /*#__PURE__*/React.createElement("rect", {
  width: 60.784,
  height: 1.305,
  x: 142.137,
  y: 211.698,
  fill: "#C8CCCF",
  rx: 0.653
}), /*#__PURE__*/React.createElement("path", {
  fill: "#59DD7D",
  d: "M84.866 33.54h42.705v1.958H84.866z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#C8CCCF",
  strokeLinecap: "round",
  strokeWidth: 1.5,
  d: "M12.245 229.832h259.359"
})));

export default SvgSuccessPreviewAndCustomize;